import React, { useState, useEffect } from 'react'
import HeroPageLink from './HeroPageLink'

const Result = ({ hero, restart, checkForRedirect }) => {
    const [ vidSrc, setVidSrc ] = useState()
    useEffect(() => { setVidSrc(`https://www.youtube.com/embed/${hero.shortId}?autoplay=1`)}, [hero]);
    useEffect(() => {checkForRedirect()}, [hero, checkForRedirect])

    const renderLoading = () => <div className="loading">Finding your hero</div>

    const renderResult = () => {
        return (
            
            <div>
                <p className="progress">Prediction Complete</p>
                <h5>You could make a great <br className="portrait-wrap"/><span className="feature-text">{hero.name}</span>!</h5>

                <div className="result-container">

                    <div className="result-interface">
                        <div>
                            <HeroPageLink hero={hero} />                  
                        </div>
                        <div>
                            <button onClick={restart}>Try again</button>
                        </div>
                    </div>

                    <div className="result-info">
                        <iframe title="hero-vid" width="100%" height="100%" src={vidSrc}/>
                    </div>
        
                </div>
            </div>
        )

    }

    return !hero.name ? renderLoading() : renderResult()
}

export default Result
